<div class="preloader" *ngIf="!pageLoaded">
  <app-cube-loader></app-cube-loader>
</div>
